import { defineMessages } from "react-intl";

const messages = defineMessages({
  activities: {
    id: "settings.data.restorableRecords.activities",
    defaultMessage: "Activities",
    description: "Title of organization details general tab",
  },
  cancel: {
    id: "settings.data.restorableRecords.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button title",
  },
  companies: {
    id: "settings.data.restorableRecords.companies",
    defaultMessage: "Companies",
    description: "Title of organization details general tab",
  },
  confirmTitle: {
    id: "settings.data.restorableRecords.restore.confirmTitle",
    defaultMessage: "Are you sure?",
    description: "Confirm restore modal title",
  },
  deals: {
    id: "settings.data.restorableRecords.deals",
    defaultMessage: "Deals",
    description: "Title of organization details general tab",
  },
  noAccess: {
    id: "settings.data.restorableRecords.noAccess",
    defaultMessage:
      "You do not have access to this page because of your permissions - please contact your admin for more info",
    description: "No access message for restorable records page",
  },
  people: {
    id: "settings.data.restorableRecords.people",
    defaultMessage: "People",
    description: "Title of organization details general tab",
  },
  restore: {
    id: "settings.data.restorableRecords.restore",
    defaultMessage: "Restore",
    description: "Restore button title",
  },
  restoreSelected: {
    id: "settings.data.restorableRecords.restoreSelected",
    defaultMessage: "{count} {count, plural, one {record} other {records}} selected",
    description: "Restore button title",
  },
  subtext: {
    id: "settings.data.restorableRecords.subtext",
    defaultMessage:
      "Restorable records are kept for {count} {count, plural, one {day} other {days}} before permanent deletion.",
    description: "Title of settings Restorable Records page subtext",
  },
  title: {
    id: "settings.data.restorableRecords.title",
    defaultMessage: "Restorable Records",
    description: "Title of settings Restorable Records page",
  },
});

export default messages;
